export default __webpack_public_path__ + "7b13c155ed2e48787a68882688e2fde2.png";